module.exports = __webpack_public_path__ + "img/sleeve_flounce_length.c0c90df7.png";